module.exports = __webpack_public_path__ + "static/img/storage_bgc.4b0c1be.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/storage_bgc.png
// module id = 194
// module chunks = 1 3